import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-excel',
  templateUrl: './icon-excel.component.html',
  styleUrls: ['./icon-excel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconExcelComponent {}
